import 'firebase/compat/analytics';
import type * as admin from 'firebase-admin';
import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';
import 'firebase/compat/functions';

import { webConfig } from '@gitbook/env';

import { connectToFirebaseEmulators } from './emulators';
import type { DatabaseSetupTestsOptions } from './types';

export { firebase };

if (process.env.NODE_ENV === 'test') {
    throw new Error(
        'Firebase cloud services should not be used in tests, the test runner should import the test environment.'
    );
}

const app = firebase.initializeApp(webConfig.firebase);

connectToFirebaseEmulators(app);

export function firebaseAdminApp(): admin.app.App {
    throw new Error('only implemented in test environment');
}

export function storage() {
    return app.storage();
}

/**
 * Setup lifecycle for unit tests. This method is defined in the mock.
 */
export function setupTests(_options?: DatabaseSetupTestsOptions) {
    throw new Error('This method cannot be used in the browser env');
}
